import { EnergyUnit, IPer100Energy } from "shared/hubrise/models"

const KCAL_TO_KJ = 4.184

/**
 * Converts IPer100Energy between kcal and kJ.
 * @param energy
 * @param to
 */
export const convertEnergy = (energy: IPer100Energy, to: EnergyUnit): IPer100Energy => {
  if (energy.unit === to) return energy

  // Returns the number of decimal places in the value. Example: 10.5 -> 1, 0.123 -> 3, 100 -> 0
  const decimalPlaces = (value: number): number => {
    const str = String(value)
    const dotIndex = str.indexOf(".")
    return dotIndex === -1 ? 0 : str.length - dotIndex - 1
  }

  const convertValue = (value: number, to: EnergyUnit): number => {
    const converted = to === "kJ" ? value * KCAL_TO_KJ : value / KCAL_TO_KJ
    return parseFloat(converted.toFixed(decimalPlaces(value)))
  }

  return {
    unit: to,
    lower: convertValue(energy.lower, to),
    upper: energy.upper !== null ? convertValue(energy.upper, to) : null,
  }
}
